export default __webpack_public_path__ + "static/stream-thumbnail-c0adeb0c1f5e5b95838ff42b8de3fe5a.png";